<script>
import { Userpilot } from 'userpilot'
import { mapGetters } from 'vuex'

import ProvidesIsMobileMixin from '~/mixin/ProvidesIsMobileMixin.js'

export default {
  mixins: [ProvidesIsMobileMixin],

  computed: mapGetters({
    user: 'auth/user',
  }),

  created() {
    // check if user is logged in
    if (this.user) {
      Userpilot.identify(this.user.id, {
        name: this.user.name,
        email: this.user.email,
        created_at: this.user.created_at,
      })
    }
  },
}
</script>

<template>
  <child />
</template>
